export default __webpack_public_path__ + "static/media/customer.f6529397.svg";